import React, { useEffect } from 'react';
import classNames from 'classnames';
import { disableScroll, enableScroll } from '@helpers/noScroll';
import './Modal.scss';

interface ModalProps {
  header?: React.ReactNode;
  subHeader?: React.ReactNode;
  onClose: () => void;
  className?: string;
  children: React.ReactNode;
  isOuterModal?: boolean;
}

export const Modal = ({ children, header, subHeader, onClose, className, isOuterModal }: ModalProps) => {
  useEffect(() => {
    disableScroll();
    return () => {
      isOuterModal && enableScroll();
    };
  }, []);

  return (
    <>
      <div className='modal-overlay' />
      <div className={classNames('modal', className)}>
        <div className='modal-header'>
          <div className='modal-header-main'>{header}</div>
          <div className='modal-header__close'>
            <i onClick={onClose} className='icon-symbol-close' />
          </div>
        </div>
        {subHeader && <div className='modal-sub-header'>{subHeader}</div>}
        <div className='modal-content'>{children}</div>
      </div>
    </>
  );
};
